module.exports = __webpack_public_path__ + "img/access@2x.b7a39ed2.png";